export const colors = {
    color: "orange",
    primary: "#d88027",
    secondary: "#3d3e3d",
    bgColor: "#f0f2f5",
    btnColor: "white",
    alertRed: "#fff5f5",
    alertGreen: "#f5fff6",
    alertYellow: "#fffbf5",
}